export default {
    PL: {
        PRODUCTION: 'https://strefa.tms.pl',
        TEST: 'https://master-strefa.test.tms.pl',
    },
    OANDA: {
        PRODUCTION: 'https://www.oanda.com/',
        STAGE: 'https://www-stg.stage.oanda.com/',
        TEST: 'https://master-strefa.test.tms.pl/',
    },
    HUB: {
        PRODUCTION: 'https://hub.oanda.com/',
        TEST: 'https://stage-hub.test.tms.pl/',
    },
    OTHERS: {
        PRODUCTION: 'https://client.tmsbrokers.com/',
        STAGE: 'https://master-strefa.test.tms.pl/',
        TEST: 'https://master-strefa.test.tms.pl/',
    },
};
